export const EVENT_NAME = {
  RACE_CELL_CLICK: "Race Cell Clicked"
};
